import { useFormContext } from '@calendly/form'
import { useCallback } from 'react'

import { isSameMembership } from '../../helpers'
import { useSetValuesAndSubmit } from '../../hooks'

export const useSelectTeamGroupHost = (eventType, selectedMembership, callback) => {
  const isNewEventType = !eventType?.id
  const { values: { memberships } } = useFormContext()
  const setValues = useSetValuesAndSubmit({ withSubmit: !isNewEventType })

  return useCallback((eventTypeMembership) => {
    if (callback) { callback() }

    if (isSameMembership(selectedMembership, eventTypeMembership)) return

    const updatedMemberships = memberships.map((membership) => (
      isSameMembership(membership, eventTypeMembership)
        ? { ...membership, enabled: true, location_organizer: true }
        : { ...membership, enabled: false, location_organizer: false }
    ))

    setValues((values) => ({
      ...values,
      memberships: updatedMemberships
    }))
  }, [callback, memberships, selectedMembership, setValues])
}
